<template>
  <div>
    <el-table
      :data="tableData"

      border
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 100%">
      <el-table-column

        prop="count"
        label="编号"
        width="60">
      </el-table-column>

      <el-table-column

        prop="assess"
        label="评价"
        width="500">
      </el-table-column>

      <el-table-column label="操作" width="300">

        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--    添加按钮-->
    <el-button @click="addSkill()" style="margin-top: 20px" type="primary" plain>添加内容</el-button>
    <el-dialog title="添加评价" :visible.sync="addFormVisible" width="500px" top="10px"
               @close="cancel('addData')"
    >
      <el-form :model="addData" :rules="rules" ref="addData" label-width="100px" class="demo-ruleForm">

        <el-form-item label="内容:" prop="content">
          <el-input style="width: 250px;margin-left: 10px;margin-top: 10px"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder="请输入内容"
                    v-model="addData.assess">
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleInsert('addData')">添加</el-button>
          <el-button @click="resetForm('addData')">重置</el-button>
        </el-form-item>

      </el-form>
    </el-dialog>

    <!--    对话框-->
    <el-dialog title="评价信息" :visible.sync="dialogFormVisible" width="500px" top="8%"
               @close="cancel('formData')"
    >

      <el-form :model="formData" :rules="rules" ref="formData" label-width="100px" class="demo-ruleForm">

        <el-form-item label="内容:" prop="assess">
          <el-input style="width: 250px;margin-left: 10px;margin-top: 10px"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder="请输入内容"
                    v-model="formData.assess">
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('formData')">提交</el-button>
          <el-button @click="resetForm('formData')">重置</el-button>
        </el-form-item>

      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from "../../utils/axiosUtils";

export default {
  name: "CommentManager",
  data() {
    return {
      id: null,
      dialogFormVisible: false,
      addFormVisible: false,
      adminInfo: {},
      tableData: [
        {
          count: null,
          id: null,
          assess: null,
        }
      ],
      addData:
        {
          assess: null,
          adminId: null,
        },
      formData: {},
      rules: {
        //内容
        assess: [
          {required: true, message: '请输入内容', trigger: 'blur'}
        ],

      },
    }
  },
  methods: {
    //添加
    addSkill() {

      this.addFormVisible = true;
    },
    //添加技能
    handleInsert(addData) {
      let that = this;
      that.addData.adminId = that.id;
      // console.log(that.addData)
      this.$refs[addData].validate((valid) => {
        if (valid) {
          this.$confirm('此操作将添加用户信息，是否继续?', '警告', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            request({
              url: '/admin/insertAdminUserAssess',
              methods: 'get',
              params: {
                insertAdminUserAssess: that.addData,
                adminInfo: that.adminInfo
              }
            }).then(response => {
              this.addFormVisible = false;
              if (response.data.flag) {
                this.$notify.success({
                  title: '评价',
                  duration: 2000,
                  message: response.data.message
                });
                this.AdminUserAssessList();
              } else {
                this.$notify.success({
                  title: '评价',
                  duration: 2000,
                  message: response.data.message
                });
              }
            }).catch(e => {
              this.$notify({
                title: '评价',
                type: 'error',
                message: '网络错误',
              });
            })
          }).catch(() => {
            this.$notify({
              title: '评价',
              type: 'success',
              message: '已取消',
            });
          })
        }
      })
    },
    //删除
    handleDelete(index, row) {
      let that = this;
      // console.log(row.id)
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/admin/deletedAdminAssess',
          method: 'get',
          params: {
            id: row.id,
            adminInfo: that.adminInfo
          }
        }).then(repose => {
          // console.log(repose);
          if (repose.data.flag) {
            this.$notify.success({
              title: '删除',
              duration: 2000,
              message: '删除成功！'
            });
            that.AdminUserAssessList();
          } else {
            this.$notify({
              type: 'error',
              title: '评价',
              message: '删除失败!'
            })
          }
        }).catch(e => {
          this.$notify({
            type: 'error',
            title: '评价',
            message: '网络错误!'
          })
        })
      }).catch(() => {
        this.$message({
          type: 'success',
          message: '已取消'
        })
      })
    },
    //编辑
    handleEdit(index, row) {
      this.formData = row;
      this.dialogFormVisible = true;
    },
    //编辑提交
    submitForm(formData) {
      let that = this;
      this.$refs[formData].validate((valid) => {
        if (valid) {
          this.$confirm('此操作将修改用户信息，是否继续?', "警告", {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            request({
              url: '/admin/updataAdminUserAssess',
              methods: 'get',
              params: {
                adminUserAssessJson: that.formData,
                adminInfo: that.adminInfo
              }
            }).then(response => {
              that.dialogFormVisible = false;
              if (response.data.flag) {
                this.$notify.success({
                  title: '修改',
                  duration: 2000,
                  message: response.data.message
                });
                this.AdminUserAssessList();
              }
            })
          }).catch(() => {
            this.$message({
              type: 'success',
              message: '取消',
            });
          })
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    },
    //重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //取消修改用户
    cancel(formName) {
      this.$refs[formName].resetFields();
      this.editDialogVisible = false;
    },
    //技能获取数据
    AdminUserAssessList() {
      let that = this;
      request({
        url: '/admin/getAdminAssess',
        method: 'get',
        params: {
          id: that.id,
        }
      }).then(response => {

        if (response.data.data === null) {
          this.tableData = null
        } else {
          let count = 1;
          // console.log(response.data.data)
          response.data.data.forEach(value => {
            value.count = count++;
          })

          that.tableData = response.data.data;
          // console.log( that.tableData)
        }
      })
    }
  },

  mounted() {
    var item = window.sessionStorage.getItem('adminInfo');
    let data = JSON.parse(item);
    this.id = data.id
    this.adminInfo = data;
    this.AdminUserAssessList();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/AssessManager.vue